import { FieldMeta } from '@tanstack/react-form';

// @ts-expect-error Field meta requires generic props after v0.42.0 - BUT this does not break
export const FieldInfo = ({ fieldMeta }: { fieldMeta: FieldMeta }) => {
  return (
    <>
      {fieldMeta && fieldMeta.isTouched && fieldMeta.errors?.length ? (
        <p className="text-xs text-red-500">{fieldMeta.errors.join(', ')}</p>
      ) : null}
      {/* {fieldMeta && fieldMeta.isValidating ? 'Validating...' : null} */}
    </>
  );
};
